// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c7fda742","743":"c4eb88e1","963":"cf6a33ec"}[chunkId] + ".chunk.js";
};